import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastData {
  /** Testo principale della notifica. */
  message: string;
  /** Riga in grassetto sopra al messaggio; se assente il toast è a riga singola. */
  title?: string;
  type: ToastType;
  /** Etichetta del pulsante di azione (es. "Annulla"); se assente il pulsante non compare. */
  actionLabel?: string;
  /**
   * Durata in ms, usata qui solo per animare la barra di avanzamento in modo
   * sincrono con l'auto-dismiss gestito da MatSnackBar. 0 = toast persistente,
   * barra nascosta.
   */
  duration: number;
}

/**
 * Varianti outline: le glifi piene di Material (check_circle, error, info) sono
 * dischi colorati e leggerebbero come un badge, non come un'icona flat.
 */
const TOAST_ICONS: Record<ToastType, string> = {
  success: 'check_circle_outline',
  error: 'error_outline',
  warning: 'warning_amber',
  info: 'info_outline',
};

/**
 * Contenuto custom del toast, aperto tramite MatSnackBar.openFromComponent().
 * Non va istanziato a mano: usare ToastService.
 */
@Component({
  selector: 'izy-toast',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  readonly icon: string;

  constructor(
    private snackBarRef: MatSnackBarRef<ToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData,
  ) {
    this.icon = TOAST_ICONS[data.type];
  }

  /** Chiude notificando il chiamante tramite snackBarRef.onAction(). */
  onAction(): void {
    this.snackBarRef.dismissWithAction();
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
